// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dbc-dygraphs-line{width:100%;height:100%}.dygraph-legendNN{background-color:rgba(209,236,241,.95)!important;padding:4px;border:1px solid #bee5eb;border-radius:4px;pointer-events:none;width:240px;position:absolute;margin-top:40px}.dbc-dygraphs-dth .dygraph-legend2{font-size:14px;text-align:left;margin-left:65px}.dbc-dygraphs-dth .dygraph-title2{font-size:18px;text-align:center}", ""]);
// Exports
module.exports = exports;
